import { theme } from '@frameio/vapor-theme';
import type { AnimationEases, AnimationOptions } from '../types';

/**
 * @deprecated Avoid using this function as this module is deprecated.
 */
export function convertEasesOptions(
  draft: AnimationOptions
): KeyframeAnimationOptions {
  // @ts-expect-error FIXME(strictNullChecks)
  draft.easing = resolveEasing(draft.easing);
  return draft;
}

// Support all preset theme eases
const { curves } = theme.transitions;

function resolveEasing(ease: AnimationEases | string): string {
  // @ts-expect-error FIXME(noImplicitAny)
  return curves[ease] ? curveToCubicBezier(curves[ease]) : ease;
}

/**
 * @deprecated Avoid using this function as this module is deprecated.
 */
export function curveToCubicBezier(
  curve: (typeof theme.transitions.curves)[keyof typeof theme.transitions.curves]
): string {
  return `cubic-bezier(${curve.join(',')})`;
}
